import testUa from './testUa';

import isDuiTang from './isDuiTang';

import isNaiYou from './isNaiYou';

import isInApp from './isInApp';

import isWeiXin from './isWeiXin';

import isQQ from './isQQ';

import isWeiBo from './isWeiBo';

import isMEIZU from './isMEIZU';

import getPhoneType from './getPhoneType';

import getAppVersion from './getAppVersion';

import appVersionCompare from './appVersionCompare';

import isIos from './isIos';

import isAndroid from './isAndroid';

import isWindowsPhone from './isWindowsPhone';

import isSymbian from './isSymbian';

import isFireFox from './isFireFox';

import isChrome from './isChrome';

import isTablet from './isTablet';

import isPhone from './isPhone';

import isPc from './isPc';

import sdkVersion from './sdkVersion';

import isSupportFull from './isSupportFull';

const DtPlatform = {
  testUa,
  isDuiTang,
  isNaiYou,
  isInApp,
  isWeiXin,
  isQQ,
  isWeiBo,
  isMEIZU,
  getPhoneType,
  getAppVersion,
  appVersionCompare,
  isIos,
  isAndroid,
  isWindowsPhone,
  isSymbian,
  isFireFox,
  isChrome,
  isTablet,
  isPhone,
  isPc,
  sdkVersion,
  isSupportFull,
};

export {
  testUa,
  isDuiTang,
  isNaiYou,
  isInApp,
  isWeiXin,
  isQQ,
  isWeiBo,
  isMEIZU,
  getPhoneType,
  getAppVersion,
  appVersionCompare,
  isIos,
  isAndroid,
  isWindowsPhone,
  isSymbian,
  isFireFox,
  isChrome,
  isTablet,
  isPhone,
  isPc,
  sdkVersion,
  isSupportFull,
};

export default DtPlatform;
